(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/animations/core.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/animations/core.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.animations = svs.tur.ball.animations || {};
class Core {
  fadeIn(ball) {
    const tl = gsap.timeline();
    tl.fromTo(ball.$el, {
      duration: 1,
      opacity: 0
    }, {
      opacity: 1
    });
    return tl;
  }
  fadeOut(ball) {
    return ball.fadeIn().reverse(0);
  }
  rollIn(ball) {
    const tl = new gsap.timeline();
    tl.fromTo(ball.$el, {
      opacity: 0,
      x: -100,
      rotation: -720
    }, {
      duration: 1.5,
      opacity: 1,
      x: 0,
      rotation: 0,
      ease: 'elastic.out(1, 0.5)'
    });
    return tl;
  }
  wave(ball) {
    const tl = new gsap.timeline({
      defaults: {
        duration: 0.3
      }
    });
    tl.to(ball.$el, {
      duration: 0.2,
      y: -10
    });
    tl.to(ball.$el, {
      duration: 0.5,
      y: 0,
      ease: 'back.out'
    });
    return tl;
  }
  bounceIn(ball) {
    const tl = gsap.timeline();
    CustomBounce.create('ballBounce', {
      strength: 0.6,
      squash: 2,
      squashID: 'ballBounce-squash'
    });
    gsap.set(ball.$el, {
      y: 0,
      x: -50,
      scale: 0
    });
    tl.to(ball.$el, 0.2, {
      y: -60,
      scale: 1,
      opacity: 1
    });
    if (this.kungKeno) {
      tl.to(ball.$el, 0.7, {
        y: 0,
        ease: 'bounce.out'
      }).to(ball.$el, 1.5, {
        x: 0
      }, '-=0.85');
    } else {
      tl.to(ball.$el, 0.7, {
        y: 0,
        ease: 'ballBounce'
      }).to(ball.$el, 0.7, {
        scaleX: 1.3,
        scaleY: 0.7,
        ease: 'ballBounce-squash',
        transformOrigin: 'center bottom'
      }, '-=0.7').to(ball.$el, 1, {
        x: 5
      }, '-=0.85').to(ball.$el, 0.4, {
        rotation: 30,
        transformOrigin: 'center center'
      }, 0.7).to(ball.$el, 0.6, {
        rotation: 0,
        x: 0,
        ease: 'back(4)'
      });
    }
    tl.set(ball.$el, {
      clearProps: 'all'
    });
    return tl;
  }
  clear(ball) {
    const tl = gsap.timeline();
    tl.to(ball.$number, {
      duration: 0.3,
      y: -20,
      opacity: 0
    });
    tl.to(ball.$el, {
      duration: 0.2,
      opacity: 0.5
    }, '-=0.2');
    tl.call(() => {
      ball.clearNumber();
    });
    tl.set([ball.$number, ball.$el], {
      clearProps: 'all'
    });
    return tl;
  }
  shrink(ball) {
    return gsap.to(ball.$el, {
      duration: 0.15,
      scale: 0,
      width: 0
    });
  }
  grow(ball) {
    const width = ball.getAbsoluteWidth(ball.$el);
    return gsap.fromTo(ball.$el, {
      scale: 0,
      width: 0
    }, {
      duration: 0.15,
      scale: 1,
      width,
      clearProps: 'all'
    });
  }
  reset(ball) {
    const tl = gsap.timeline();
    tl.to(ball.$number, {
      duration: 0.1,
      scale: 0
    });
    tl.to(ball.$el, {
      duration: 0.15,
      scale: 0,
      width: 0
    });
    tl.call(() => {
      ball.remove();
    });
    return tl;
  }
}
svs.tur.ball.animations.Core = new Core();

 })(window);